import React from 'react';
import {
  ListRuleInstancesQuery,
  OptimisticQueryUpdate,
  useOptimisticQuery,
  QuestionRuleInstanceWithTags,
} from '@jupiterone/jupiter-web-toolkit';
import {
  QuestionRuleTagsResponse,
  useQuestionRuleTags,
} from 'jupiter-web-alerts/src/hooks/graphql/rule';

export interface RulesListProviderProps {
  children: React.ReactNode;
}

export type TagsAndRulesWithTags = {
  rules: QuestionRuleInstanceWithTags[] | undefined;
  loadingRules: boolean;
  getRuleUpdater: <TT>(
    transformCachedResults: (
      cacheEntry: QuestionRuleInstanceWithTags[],
      mutationResult: TT
    ) => QuestionRuleInstanceWithTags[]
  ) => OptimisticQueryUpdate;
  tags: QuestionRuleTagsResponse | undefined;
  loadingTags: boolean;
  refetchTags: VoidFunction;
};

export const RulesListContext = React.createContext<
  TagsAndRulesWithTags | undefined
>(undefined);

export const RulesListProvider = ({ children }: RulesListProviderProps) => {
  const {
    data: tags,
    loading: loadingTags,
    refetch: refetchTags,
  } = useQuestionRuleTags();

  const {
    loading: loadingRules,
    data: rules,
    getUpdater: getRuleUpdater,
  } = useOptimisticQuery<QuestionRuleInstanceWithTags[]>(
    ListRuleInstancesQuery,
    {
      dataPath: 'listRuleInstances.questionInstances',
    }
  );

  const result = {
    rules,
    loadingRules,
    getRuleUpdater,
    tags,
    loadingTags,
    refetchTags,
  };

  return (
    <RulesListContext.Provider value={result}>
      {children}
    </RulesListContext.Provider>
  );
};
